var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPineTree = function SvgPineTree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.74 29.425-7.573-9.737H32.5a.938.938 0 0 0 .744-1.51l-12.5-16.25a.937.937 0 0 0-1.488 0l-12.5 16.25a.938.938 0 0 0 .744 1.51h4.333L4.26 29.425A.937.937 0 0 0 5 30.938h14.063V37.5a.937.937 0 1 0 1.875 0v-6.562H35a.937.937 0 0 0 .74-1.513m-28.823-.362 7.574-9.738a.937.937 0 0 0-.74-1.512H9.404L20 4.038l10.596 13.775H26.25a.936.936 0 0 0-.74 1.512l7.573 9.738z"
  })));
};
export default SvgPineTree;